import { useMutation } from "react-query"
import api from "../../client"
import { queryClient } from "../../query"
import { CreateOrderTemplateOrderResponseData } from "../../types/order-template"

const postData = async (uuid: string | undefined)
    : Promise<CreateOrderTemplateOrderResponseData> => {
    const { data } = await api.post<CreateOrderTemplateOrderResponseData>(
        `/order-templates/${uuid}/order`,
    )

    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useOrderTemplateCreateOrder = (uuid: string | undefined) => {
    return useMutation(() => {
        return postData(uuid)
    })
}

export const useOrderTemplateCreateOrderPostponed = () => {
    return useMutation((uuid: string | undefined) => {
        return postData(uuid)
    })
}
